module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-core");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(0);

var _styles = __webpack_require__(4);

var _styles2 = _interopRequireDefault(_styles);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Fixed-width Cell, its width specified using CSS dimensions (such as pixels,
 * %, or other). WARNING: This should only be used only when the grid columns are
 * explicitly not being used. This will almost certainly not align to the grid and
 * may cause other cells to also not align.
 *
 * This component renders a [View](#view) that
 * uses Flex Box and has a [flex-basis](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-basis)
 * of the specified "width" and [flex-shrink](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-shrink)
 * of 0.
 *
 * Typically this component will be used as a child of a [Row](#row),
 * but it's not a requirement, you can use it as a descendant, as well.
 *
 * By default (with no properties specified) it will display at all
 * grid sizes. If you specify the `smallWidth`, `mediumWidth`, `largeWidth`,
 * or `width` props then the component will only be shown at those grid sizes
 * and using the specified width.
 */
var FixedWidthCell = function (_React$Component) {
    _inherits(FixedWidthCell, _React$Component);

    function FixedWidthCell() {
        _classCallCheck(this, FixedWidthCell);

        return _possibleConstructorReturn(this, (FixedWidthCell.__proto__ || Object.getPrototypeOf(FixedWidthCell)).apply(this, arguments));
    }

    _createClass(FixedWidthCell, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                style = _props.style,
                mediaSize = _props.mediaSize,
                mediaSpec = _props.mediaSpec;

            var width = FixedWidthCell.getWidth(this.props, mediaSize);

            // If no width is ever specified then we error out.
            if (width === undefined) {
                throw new Error("No width specified to FixedWidthCell.");
            } else if (width === null || width === 0) {
                // If no width is specified then we just don't render this cell
                return null;
            }

            var contents = children;

            // If the contents are a function then we call it with the mediaSize,
            // totalColumns, and width properties and render the return value.
            if (typeof contents === "function") {
                var _totalColumns = mediaSpec[mediaSize].totalColumns;

                contents = contents({ mediaSize: mediaSize, totalColumns: _totalColumns, width: width });
            }

            return React.createElement(
                _wonderBlocksCore.View,
                { style: [_styles2.default.cellFixed, (0, _utils.flexBasis)(width), style] },
                contents
            );
        }
    }], [{
        key: "getWidth",
        value: function getWidth(_ref, mediaSize) {
            var smallWidth = _ref.smallWidth,
                mediumWidth = _ref.mediumWidth,
                largeWidth = _ref.largeWidth,
                width = _ref.width;

            // If no option was specified then we just return undefined,
            // components may handle this case differently.
            // We go through all the ways in which a fixed width can be
            // specified and find the one that matches our current grid size.
            if (!smallWidth && !mediumWidth && !largeWidth && !width) {
                return undefined;
            } else if (smallWidth && mediaSize === "small") {
                return smallWidth;
            } else if (mediumWidth && mediaSize === "medium") {
                return mediumWidth;
            } else if (largeWidth && mediaSize === "large") {
                return largeWidth;
            } else if (typeof width === "function") {
                return width(mediaSize);
            } else if (width) {
                return width;
            }

            // If nothing applies then we return null (usually resulting
            // in the component not being rendered)
            return null;
        }
    }, {
        key: "shouldDisplay",
        value: function shouldDisplay(props, mediaSize) {
            return !!FixedWidthCell.getWidth(props, mediaSize);
        }
    }]);

    return FixedWidthCell;
}(React.Component);

FixedWidthCell.defaultProps = {
    smallWidth: 0,
    mediumWidth: 0,
    largeWidth: 0,
    width: 0
};
exports.default = (0, _wonderBlocksCore.MediaLayoutWrapper)(FixedWidthCell);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var matchesSize = exports.matchesSize = function matchesSize(_ref, mediaSize) {
    var small = _ref.small,
        medium = _ref.medium,
        large = _ref.large;
    return !small && !medium && !large || small && mediaSize === "small" || medium && mediaSize === "medium" || large && mediaSize === "large";
};
var flexBasis = exports.flexBasis = function flexBasis(size) {
    return {
        MsFlexBasis: size,
        MsFlexPreferredSize: size,
        WebkitFlexBasis: size,
        flexBasis: size
    };
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _aphrodite = __webpack_require__(8);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WIDE_SCREEN = "@media (min-width: 1168px)";

var styles = _aphrodite.StyleSheet.create({
    rowWrap: {
        flexDirection: "row",
        alignItems: "center"
    },

    row: {
        flexDirection: "row",
        width: "100%",
        position: "unset" // hack for report
    },

    rowMaxWidth: _defineProperty({}, WIDE_SCREEN, {
        margin: "0 auto"
    }),

    cellGrow: {
        flexGrow: 1
    },

    cellFixed: {
        flexShrink: 0
    }
});

exports.default = styles;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(0);

var _utils = __webpack_require__(3);

var _fixedWidthCell = __webpack_require__(2);

var _fixedWidthCell2 = _interopRequireDefault(_fixedWidthCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Gutter is a form of [FixedWidthCell](#fixedwidthcell) whose width is set based on the size
 * of grid currently being displayed. Used for spacing out cells from each
 * other. The gutter itself doesn't hold any content, it just spaces it out.
 *
 * Gutters are inserted automatically inside of a [Row](#row) in-between Cells.
 * You may only need to use Gutters if you're manually building your own
 * sub-grid, or some-such (this should be relatively rare).
 *
 * By default (with no properties specified) it will display at all
 * grid sizes. If you specify the `small`, `medium`, or `large`
 * props then the component will only be shown at those grid sizes.
 */
var Gutter = function (_React$Component) {
    _inherits(Gutter, _React$Component);

    function Gutter() {
        _classCallCheck(this, Gutter);

        return _possibleConstructorReturn(this, (Gutter.__proto__ || Object.getPrototypeOf(Gutter)).apply(this, arguments));
    }

    _createClass(Gutter, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                mediaSize = _props.mediaSize,
                mediaSpec = _props.mediaSpec;
            var gutterWidth = mediaSpec[mediaSize].gutterWidth;

            var shouldDisplay = (0, _utils.matchesSize)(this.props, mediaSize);

            if (!shouldDisplay) {
                return null;
            }

            return React.createElement(_fixedWidthCell2.default, { width: gutterWidth });
        }
    }]);

    return Gutter;
}(React.Component);

Gutter.defaultProps = {
    small: false,
    medium: false,
    large: false
};
exports.default = (0, _wonderBlocksCore.MediaLayoutWrapper)(Gutter);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(0);

var _styles = __webpack_require__(4);

var _styles2 = _interopRequireDefault(_styles);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A flexible-width grid cell. Expands to fill the available space.
 * Implemented using Flex Box and [flex-grow](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-grow)
 * of 1.
 *
 * Typically this component will be used as a child of a [Row](#row),
 * but it's not a requirement, you can use it as a descendant, as well.
 *
 * By default (with no properties specified) it will display at all
 * grid sizes. If you specify the `small`, `medium`, or `large`
 * props then the component will only be shown at those grid sizes.
 */
var FlexCell = function (_React$Component) {
    _inherits(FlexCell, _React$Component);

    function FlexCell() {
        _classCallCheck(this, FlexCell);

        return _possibleConstructorReturn(this, (FlexCell.__proto__ || Object.getPrototypeOf(FlexCell)).apply(this, arguments));
    }

    _createClass(FlexCell, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                style = _props.style,
                mediaSize = _props.mediaSize,
                mediaSpec = _props.mediaSpec;


            if (!FlexCell.shouldDisplay(this.props, mediaSize)) {
                return null;
            }

            var contents = children;

            // If the contents are a function then we call it with the mediaSize and
            // totalColumns properties and render the return value.
            if (typeof contents === "function") {
                var _totalColumns = mediaSpec[mediaSize].totalColumns;

                contents = contents({ mediaSize: mediaSize, totalColumns: _totalColumns });
            }

            return React.createElement(
                _wonderBlocksCore.View,
                { style: [_styles2.default.cellGrow, style] },
                contents
            );
        }
    }], [{
        key: "shouldDisplay",
        value: function shouldDisplay(props, mediaSize) {
            return (0, _utils.matchesSize)(props, mediaSize);
        }
    }]);

    return FlexCell;
}(React.Component);

FlexCell.defaultProps = {
    small: false,
    medium: false,
    large: false
};
exports.default = (0, _wonderBlocksCore.MediaLayoutWrapper)(FlexCell);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(0);

var _styles = __webpack_require__(4);

var _styles2 = _interopRequireDefault(_styles);

var _utils = __webpack_require__(3);

var _fixedWidthCell = __webpack_require__(2);

var _fixedWidthCell2 = _interopRequireDefault(_fixedWidthCell);

var _gutter = __webpack_require__(5);

var _gutter2 = _interopRequireDefault(_gutter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A Row holds all of the Cells that make up the contents of the grid. A row
 * also provides the margins on the sides and inserts the gutter spacing
 * in-between the cells. Typically this component will hold a mixture of
 * [Cell](#cell), [FlexCell](#flexcell), and [FixedWidthCells](#fixedwidthcell),
 * but it can also include any elements that could fit in a
 * [flexbox](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Flexible_Box_Layout/Basic_Concepts_of_Flexbox).
 *
 * This component will automatically attempt to insert [Gutters](#gutter)
 * in-between all child elements. Additionally, it'll perform some basic checks
 * to ensure that no impossible layouts are accidentally generated.
 *
 * Typically this component will be used as a child of a [Grid](#grid-1),
 * but it's not a requirement, you can use it as a descendant, as well.
 *
 * By default (with no properties specified) it will display at all
 * grid sizes. If you specify the `small`, `medium`, or `large`
 * props then the component will only be shown at those grid sizes.
 */
var Row = function (_React$Component) {
    _inherits(Row, _React$Component);

    function Row() {
        _classCallCheck(this, Row);

        return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
    }

    _createClass(Row, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                mediaSize = _props.mediaSize,
                mediaSpec = _props.mediaSpec,
                children = _props.children;
            var _mediaSpec$mediaSize = mediaSpec[mediaSize],
                marginWidth = _mediaSpec$mediaSize.marginWidth,
                maxWidth = _mediaSpec$mediaSize.maxWidth,
                totalColumns = _mediaSpec$mediaSize.totalColumns;

            var shouldDisplay = (0, _utils.matchesSize)(this.props, mediaSize);

            // Don't render the row if it's been disabled at this size
            if (!shouldDisplay) {
                return null;
            }

            var contents = children;

            // If the contents are a function then we call it with the mediaSize and
            // totalColumns properties and render the return value.
            if (typeof contents === "function") {
                contents = contents({ mediaSize: mediaSize, totalColumns: totalColumns });
            }

            contents = React.Children.toArray(contents);

            // Go through all of the contents and pre-emptively remove anything
            // that shouldn't be rendered and insert Gutters inbetween everything
            // that is still visible.
            var filteredContents = [];
            var hasVisibleCell = false;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = contents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var itemType = item.type && (item.type.wrappedType || item.type);
                    if (!itemType || !item.props || !itemType.shouldDisplay || typeof itemType.shouldDisplay === "function" && itemType.shouldDisplay(item.props, mediaSize)) {
                        if (hasVisibleCell) {
                            filteredContents.push(React.createElement(_gutter2.default, { key: "gutter-" + filteredContents.length }));
                        }

                        filteredContents.push(item);

                        hasVisibleCell = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return React.createElement(
                _wonderBlocksCore.View,
                { style: [_styles2.default.rowWrap, style] },
                React.createElement(
                    _wonderBlocksCore.View,
                    {
                        style: [_styles2.default.row, maxWidth && _styles2.default.rowMaxWidth, maxWidth && { maxWidth: maxWidth }]
                    },
                    React.createElement(_fixedWidthCell2.default, { width: marginWidth }),
                    filteredContents,
                    React.createElement(_fixedWidthCell2.default, { width: marginWidth })
                )
            );
        }
    }]);

    return Row;
}(React.Component);

Row.defaultProps = {
    small: false,
    medium: false,
    large: false
};
exports.default = (0, _wonderBlocksCore.MediaLayoutWrapper)(Row);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("aphrodite");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(0);

var _flexCell = __webpack_require__(6);

var _flexCell2 = _interopRequireDefault(_flexCell);

var _fixedWidthCell = __webpack_require__(2);

var _fixedWidthCell2 = _interopRequireDefault(_fixedWidthCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A Cell is a form of [FixedWidthCell](#fixedwidthcell) whose width is set
 * based on the width of the specified columns at the current grid size.
 * You will specify the number of columns that you want this component to
 * span at each grid size. This component should only be used as a child
 * of a [Row](#row).
 *
 * This component renders a [View](#view) that
 * uses Flex Box and has a [flex-basis](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-basis)
 * of the specified "width" and [flex-shrink](https://developer.mozilla.org/en-US/docs/Web/CSS/flex-shrink)
 * of 0.
 *
 * By default (with no properties specified) it will display at all
 * grid sizes. If you specify the `smallCols`, `mediumCols`, `largeCols`, or
 * `cols` props then the component will only be shown at those grid sizes and
 * using the specified column width.
 */
var Cell = function (_React$Component) {
    _inherits(Cell, _React$Component);

    function Cell() {
        _classCallCheck(this, Cell);

        return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
    }

    _createClass(Cell, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                children = _props.children,
                style = _props.style,
                mediaSize = _props.mediaSize,
                mediaSpec = _props.mediaSpec;
            // Get the settings for this particular size of grid

            var _mediaSpec$mediaSize = mediaSpec[mediaSize],
                totalColumns = _mediaSpec$mediaSize.totalColumns,
                gutterWidth = _mediaSpec$mediaSize.gutterWidth,
                marginWidth = _mediaSpec$mediaSize.marginWidth;


            var cols = Cell.getCols(this.props, mediaSize);

            // If no columns are specified then we assume we're rendering
            // a flexible-width cell (flex: grow)
            if (cols === undefined) {
                return React.createElement(
                    _flexCell2.default,
                    { style: style },
                    children
                );
            } else if (cols === null || cols === 0) {
                // If no columns are specified then we just don't render this cell
                return null;
            }

            if (cols > totalColumns) {
                throw new Error("Specified columns " + cols + " is greater than the maximum " + (totalColumns + " at the " + mediaSize + " grid size."));
            }

            // We need to start by calculating the total width of all the "content"
            // We do this by starting with the full width (100%) and then
            // subtracting all of the gutter spaces inbetween the cells
            // (gutterWidth * (totalColumns - 1)) and the width of the two margins
            // (marginWidth * 2).
            var contentWidth = "(100% - " + gutterWidth * (totalColumns - 1) + "px - " + marginWidth * 2 + "px)";

            // Now that we have the full width we can calculate the width of this
            // particular cell by multiplying the full width (allCellWidth) by
            // the ratio of this cell (cols / totalColumns). But we then need to
            // add back in the missing gutter widths:
            // (gutterWidth * (cols - 1)). This gives us to full width of
            // this particular cell.
            var calcWidth = "calc(" + contentWidth + " * " + cols / totalColumns + " + " + gutterWidth * (cols - 1) + "px)";

            var contents = children;

            // If the contents are a function then we call it with the mediaSize,
            // totalColumns, and cols properties and render the return value.
            if (typeof contents === "function") {
                contents = contents({ mediaSize: mediaSize, totalColumns: totalColumns, cols: cols });
            }

            // Render a fixed-width cell (flex-basis: size, flex-shrink: 0)
            // that matches the intended width of the cell
            return React.createElement(
                _fixedWidthCell2.default,
                { width: calcWidth, style: style },
                contents
            );
        }
    }], [{
        key: "getCols",
        value: function getCols(_ref, mediaSize) {
            var smallCols = _ref.smallCols,
                mediumCols = _ref.mediumCols,
                largeCols = _ref.largeCols,
                cols = _ref.cols;

            // If no option was specified then we just return undefined,
            // components may handle this case differently.
            // We go through all the ways in which a fixed width can be
            // specified and find the one that matches our current grid size.
            if (!smallCols && !mediumCols && !largeCols && !cols) {
                return undefined;
            } else if (smallCols && mediaSize === "small") {
                return smallCols;
            } else if (mediumCols && mediaSize === "medium") {
                return mediumCols;
            } else if (largeCols && mediaSize === "large") {
                return largeCols;
            } else if (typeof cols === "function") {
                return cols(mediaSize);
            } else if (cols) {
                return cols;
            }

            // If nothing applies then we return null (usually resulting
            // in the component not being rendered)
            return null;
        }
    }, {
        key: "shouldDisplay",
        value: function shouldDisplay(props, mediaSize) {
            var cols = Cell.getCols(props, mediaSize);
            return cols !== null && cols !== 0;
        }
    }]);

    return Cell;
}(React.Component);

Cell.defaultProps = {
    smallCols: 0,
    mediumCols: 0,
    largeCols: 0,
    cols: 0
};
exports.default = (0, _wonderBlocksCore.MediaLayoutWrapper)(Cell);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cell = __webpack_require__(9);

Object.defineProperty(exports, "Cell", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cell).default;
  }
});

var _fixedWidthCell = __webpack_require__(2);

Object.defineProperty(exports, "FixedWidthCell", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fixedWidthCell).default;
  }
});

var _flexCell = __webpack_require__(6);

Object.defineProperty(exports, "FlexCell", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_flexCell).default;
  }
});

var _gutter = __webpack_require__(5);

Object.defineProperty(exports, "Gutter", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_gutter).default;
  }
});

var _row = __webpack_require__(7);

Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_row).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@khanacademy/wonder-blocks-grid/index.js
// module id = 1099
// module chunks = 0